var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiquidityPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7675 20.3436C16.5612 19.8453 16.6752 19.2719 17.0566 18.8905L19.7232 16.2239C20.2439 15.7032 21.0882 15.7032 21.6089 16.2239C22.1296 16.7446 22.1296 17.5888 21.6089 18.1095L21.2183 18.5L25.9994 18.5C26.7358 18.5 27.3327 19.097 27.3327 19.8333C27.3327 20.5697 26.7358 21.1667 25.9994 21.1667L17.9994 21.1667C17.4601 21.1667 16.9739 20.8418 16.7675 20.3436Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9421 24.7761C27.3234 24.3948 27.4375 23.8213 27.2311 23.3231C27.0248 22.8249 26.5386 22.5 25.9993 22.5H17.9993C17.2629 22.5 16.666 23.097 16.666 23.8333C16.666 24.5697 17.2629 25.1667 17.9993 25.1667H22.7804L22.3898 25.5572C21.8691 26.0779 21.8691 26.9221 22.3898 27.4428C22.9105 27.9635 23.7548 27.9635 24.2755 27.4428L26.9421 24.7761Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3824 9.52986C21.444 9.26446 22.5546 9.26446 23.6162 9.52986L30.7771 11.3201C32.6877 11.7977 33.9663 13.595 33.7911 15.5565L32.6881 27.9057C32.5723 29.203 31.832 30.3627 30.704 31.0139L23.9993 34.8849C22.7617 35.5994 21.2369 35.5994 19.9993 34.8849L13.2945 31.0139C12.1665 30.3627 11.4263 29.203 11.3104 27.9057L10.2074 15.5565C10.0322 13.595 11.3109 11.7977 13.2214 11.3201L20.3824 9.52986ZM22.9694 12.1169C22.3325 11.9577 21.6661 11.9577 21.0291 12.1169L13.8682 13.9071C13.2313 14.0664 12.8051 14.6654 12.8635 15.3193L13.9665 27.6684C14.0051 28.1009 14.2519 28.4874 14.6279 28.7045L21.3326 32.5755C21.7451 32.8137 22.2534 32.8137 22.6659 32.5755L29.3707 28.7045C29.7467 28.4874 29.9934 28.1009 30.032 27.6684L31.135 15.3193C31.1934 14.6654 30.7672 14.0664 30.1304 13.9071L22.9694 12.1169Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidityPool);
export default __webpack_public_path__ + "static/media/liquidity-pool.11ac7a2051f0b9f22ba3f01e7f405302.svg";
export { ForwardRef as ReactComponent };